import Vue from "vue";
import { Component } from "vue-property-decorator";
import SupervisorAssetRestModel from "../../../models/rest/supervisor/supervisorAssetRestModel";
import SupervisorRestModel from "../../../models/rest/supervisor/supervisorRestModel";

@Component
export default class SaveSupervisorDialog extends Vue {
    needSaveSupervisorAsLogisticLoad: boolean = true;
    needCopySupervisorToMarwayTransportBranch: boolean = true;

    get showDialog(): boolean {
        return this.$store.direct.state.supervisor.showSaveSupervisorDialog;
    }

    get titleText(): string {
        return this.$store.direct.state.supervisor.titleSaveSupervisorDialog;
    }

    get messageText(): string {
        return this.$store.direct.state.supervisor.messageSaveSupervisorDialog;
    }

    get supervisorId(): number {
        return this.$store.direct.state.supervisor.supervisorIdSaveSupervisorDialog;
    }

    get supervisorHasLogisticLoadsSaveSupervisorDialog(): boolean {
        return this.$store.direct.state.supervisor.supervisorHasLogisticLoadsSaveSupervisorDialog;
    }

    get supervisorWasCopiedToMarwayTransportBranch(): boolean {
        return this.$store.direct.state.supervisor.supervisorWasCopiedToMarwayTransportBranch;
    }

    get currentUserRoles(): string[] {
        return this.$store.direct.state.auth.userRoles;
    }

    get supervisor(): SupervisorRestModel {
        return this.$store.direct.state.supervisor.supervisor;
    }

    get supervisorAssets(): SupervisorAssetRestModel {
        return this.$store.direct.state.supervisor.supervisorAssets;
    }

    created() {
        window.addEventListener('keydown', (e) => {
            if (e.key == 'Enter') {
                this.okClick();
            };
        });
    }

    saveSupervisorAsLogisticLoad(supervisorId: number) {
        this.$store.direct.dispatch.logistic.saveSupervisorAsLogisticLoad({ supervisorId: supervisorId });
    }

    copySupervisorToMarwayTransportBranch(supervisorId: number) {
        this.$store.direct.dispatch.supervisor.copySupervisorToMarwayTransportBranch({ supervisorId: supervisorId });
    }

    async saveSupervisorLogisticLoadDisponentComment(supervisorId: number, supervisorLogisticLoadDisponentComment: string) {
        await this.$store.direct.dispatch.supervisor.saveSupervisorLogisticLoadDisponentComment({ supervisorId: supervisorId, supervisorLogisticLoadDisponentComment: supervisorLogisticLoadDisponentComment });
    }

    async okClick() {
        if (this.showDialog == true) {
            await this.$store.direct.dispatch.supervisor.isConfirmedSaveSupervisorDialog();

            this.saveSupervisorLogisticLoadDisponentComment(this.supervisorId, this.supervisor.logisticLoadDisponentComment).then(() => {
                if (this.needSaveSupervisorAsLogisticLoad && this.supervisor.isPreliminary) {
                    this.saveSupervisorAsLogisticLoad(this.supervisorId);
                }
            });
            if (this.needCopySupervisorToMarwayTransportBranch && !this.supervisorWasCopiedToMarwayTransportBranch && !this.supervisor.isPreliminary && this.supervisor.locationId != 9 && this.supervisor.shippingCompanyId == this.supervisorAssets.marwayTransportBranchAssignedContractorId) {
                this.copySupervisorToMarwayTransportBranch(this.supervisorId);
            }
        }
    }

    async backToListClick() {
        await this.$store.direct.dispatch.supervisor.isNotConfirmedSaveSupervisorDialog();
    }
}
